import { connect } from 'react-redux';
// eslint-disable-next-line object-curly-newline
import { Route, Switch, useRouteMatch } from 'react-router';
import { urls } from '../../../Constants';
import { OutwardingImagesPage } from '../../../Pages/Analytics/OutwardingAnalysis';

const getSubURL = (entity) => {
	const baseEntity = urls.APP_OUTWARDING_IMAGES;
	return entity.slice(baseEntity.length);
};

const OutwardingAnalyticsRoutes = () => {
	const { path } = useRouteMatch();
	return (
		<Switch>
			<Route path={`${path}${getSubURL(urls.APP_OUTWARDING_IMAGES)}`}>
				<OutwardingImagesPage />
			</Route>
		</Switch>
	);
};

const mapStateToProps = (state) => {
	const { navState } = state.navigation;
	return {
		navState,
	};
};

export default connect(mapStateToProps)(OutwardingAnalyticsRoutes);
